export default "__VITE_ASSET__B7JFQ9jl__"